/* Mashupstyle theme · main JS */
(function() {
  'use strict';

  // ---------- Brand tabs ----------
  function initBrandTabs() {
    document.querySelectorAll('[data-brand-tabs]').forEach(function(container) {
      var tabs = container.querySelectorAll('[data-brand-tab]');
      var panels = container.querySelectorAll('[data-brand-panel]');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-brand-tab');
          tabs.forEach(function(t) { t.classList.remove('is-active'); });
          panels.forEach(function(p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          var panel = container.querySelector('[data-brand-panel="' + target + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  // ---------- Carousel arrows ----------
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
      var scroll = carousel.querySelector('[data-carousel-scroll]');
      var left = carousel.querySelector('[data-carousel-prev]');
      var right = carousel.querySelector('[data-carousel-next]');
      if (!scroll) return;

      var step = 320;
      if (left) left.addEventListener('click', function() {
        scroll.scrollBy({left: -step, behavior: 'smooth'});
      });
      if (right) right.addEventListener('click', function() {
        scroll.scrollBy({left: step, behavior: 'smooth'});
      });
    });
  }

  // ---------- Product gallery thumbs ----------
  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var src = thumb.getAttribute('data-full-src');
          if (main && src) main.src = src;
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  // ---------- Wishlist toggle (UI only — salva in localStorage) ----------
  function initWishlist() {
    var wishlistKey = 'mashupstyle_wishlist';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch(e) {}

    document.querySelectorAll('.product-main__wishlist').forEach(function(btn) {
      var form = btn.closest('form');
      var variantInput = form ? form.querySelector('[data-variant-input]') : null;
      var id = variantInput ? variantInput.value : null;

      if (id && list.indexOf(id) !== -1) btn.classList.add('is-saved');

      btn.addEventListener('click', function() {
        if (!id) return;
        var idx = list.indexOf(id);
        if (idx === -1) { list.push(id); btn.classList.add('is-saved'); }
        else { list.splice(idx, 1); btn.classList.remove('is-saved'); }
        try { localStorage.setItem(wishlistKey, JSON.stringify(list)); } catch(e) {}
      });
    });
  }

  // ---------- Outfit: add single & add all ----------
  function addToCart(variantId, quantity) {
    var body = { id: variantId, quantity: quantity || 1, sections: 'cart-drawer' };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) {
      return r.json().then(function(json) {
        if (!r.ok) return Promise.reject(json);
        if (window.CartDrawer && json.sections && json.sections['cart-drawer']) {
          window.CartDrawer.refresh(json.sections['cart-drawer']);
        }
        return json;
      });
    });
  }

  function initOutfit() {
    document.querySelectorAll('[data-outfit-add]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var item = btn.closest('[data-outfit-item]');
        if (!item) return;
        var variantId = item.getAttribute('data-variant-id');
        btn.disabled = true;
        btn.textContent = '✓';
        addToCart(variantId, 1)
          .then(function() {
            if (window.CartDrawer) window.CartDrawer.open();
            setTimeout(function() { btn.textContent = '+'; btn.disabled = false; }, 1500);
          })
          .catch(function() { btn.textContent = '+'; btn.disabled = false; });
      });
    });

    document.querySelectorAll('[data-outfit-add-all]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var items = document.querySelectorAll('[data-outfit-item]');
        var ids = [];
        items.forEach(function(i) {
          var id = i.getAttribute('data-variant-id');
          if (id) ids.push(id);
        });
        if (ids.length === 0) return;

        btn.disabled = true;
        btn.textContent = 'Aggiunta in corso...';

        var promises = ids.map(function(id) { return addToCart(id, 1); });
        Promise.all(promises).then(function() {
          btn.textContent = 'Aggiunto ✓';
          if (window.CartDrawer) {
            window.CartDrawer.open();
            setTimeout(function() { btn.textContent = 'Aggiungi tutto'; btn.disabled = false; }, 1200);
          } else {
            setTimeout(function() { window.location.href = '/cart'; }, 600);
          }
        }).catch(function() {
          btn.textContent = 'Riprova';
          btn.disabled = false;
        });
      });
    });
  }

  // ---------- Cart quantity ----------
  function initQuantity() {
    document.querySelectorAll('[data-qty-input]').forEach(function(input) {
      var wrapper = input.parentElement;
      var minus = wrapper.querySelector('[data-qty-minus]');
      var plus = wrapper.querySelector('[data-qty-plus]');

      if (minus) minus.addEventListener('click', function() {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
        input.dispatchEvent(new Event('change'));
      });
      if (plus) plus.addEventListener('click', function() {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  // ---------- Variant selection: risolve la variante e aggiorna form/UI ----------
  function initVariantSelection() {
    document.querySelectorAll('.product-main__form').forEach(function(form) {
      var dataEl = form.querySelector('[data-product-variants]');
      var variants = [];
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      }

      var lowStockThreshold = dataEl ? (parseInt(dataEl.getAttribute('data-low-stock-threshold'), 10) || 5) : 5;
      var labelAdd = dataEl ? dataEl.getAttribute('data-label-add') : null;
      var labelSoldOut = dataEl ? dataEl.getAttribute('data-label-soldout') : null;

      var hiddenInput = form.querySelector('[data-variant-input]');
      var priceEl = form.querySelector('[data-price]');
      var stockEl = form.querySelector('[data-stock]');
      var buyBtn = form.querySelector('[data-add-button]');
      var mainImage = document.querySelector('[data-gallery-main]');

      function getSelectedOptions() {
        var values = [];
        form.querySelectorAll('.product-main__option').forEach(function(optionEl) {
          var checked = optionEl.querySelector('[data-option-selector]:checked');
          if (checked) values.push(checked.value);
        });
        return values;
      }

      function findVariant(selected) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.options || v.options.length !== selected.length) continue;
          var match = true;
          for (var j = 0; j < v.options.length; j++) {
            if (v.options[j] !== selected[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function updatePrice(variant) {
        if (!priceEl) return;
        if (variant.compare_at_price) {
          priceEl.innerHTML = '<span class="price--compare">' + variant.compare_at_price +
            '</span> <span class="price--sale">' + variant.price + '</span>';
        } else {
          priceEl.textContent = variant.price;
        }
      }

      function updateStock(variant) {
        if (!stockEl) return;
        if (!variant.available) {
          stockEl.innerHTML = '<div class="product-main__stock product-main__stock--out">' +
            '<span class="product-main__stock-dot"></span>Temporaneamente esaurito</div>';
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockThreshold) {
          stockEl.innerHTML = '<div class="product-main__stock product-main__stock--low">' +
            '<span class="product-main__stock-dot"></span>Pronta consegna · Ultimi ' +
            variant.inventory_quantity + ' pezzi</div>';
        } else {
          stockEl.innerHTML = '<div class="product-main__stock product-main__stock--ok">' +
            '<span class="product-main__stock-dot"></span>Pronta consegna</div>';
        }
      }

      function updateButton(available) {
        if (!buyBtn) return;
        buyBtn.disabled = !available;
        if (available && labelAdd) buyBtn.textContent = labelAdd;
        if (!available && labelSoldOut) buyBtn.textContent = labelSoldOut;
      }

      // Valore selezionato per ciascuna opzione, allineato per indice (null se nessuno).
      function getSelectedByIndex() {
        var vals = [];
        form.querySelectorAll('.product-main__option').forEach(function(optionEl) {
          var checked = optionEl.querySelector('[data-option-selector]:checked');
          vals.push(checked ? checked.value : null);
        });
        return vals;
      }

      // Ricalcola la disponibilità di ogni valore in base alla combinazione
      // attualmente selezionata sulle ALTRE opzioni (es. taglie disponibili per il colore scelto).
      function updateOptionAvailability() {
        var selected = getSelectedByIndex();
        form.querySelectorAll('.product-main__option').forEach(function(optionEl, oi) {
          optionEl.querySelectorAll('[data-option-selector]').forEach(function(input) {
            var hasAvailable = variants.some(function(v) {
              if (!v.available || !v.options || v.options[oi] !== input.value) return false;
              for (var k = 0; k < v.options.length; k++) {
                if (k === oi) continue;
                if (selected[k] != null && v.options[k] !== selected[k]) return false;
              }
              return true;
            });
            var label = input.closest('label');
            var target = label ? label.querySelector('.product-main__chip, .product-main__swatch') : null;
            if (target) target.classList.toggle('is-disabled', !hasAvailable);
            // Non disabilitare il valore attualmente selezionato, così resta modificabile.
            input.disabled = !hasAvailable && !input.checked;
          });
        });
      }

      form.querySelectorAll('[data-option-selector]').forEach(function(input) {
        input.addEventListener('change', function() {
          // Aggiorna l'etichetta dell'opzione selezionata
          var option = input.closest('.product-main__option');
          if (option) {
            var valueDisplay = option.querySelector('.product-main__option-value');
            if (valueDisplay) valueDisplay.textContent = input.value;
          }

          // Ricalcola quali valori sono disponibili con la nuova combinazione.
          updateOptionAvailability();

          var variant = findVariant(getSelectedOptions());

          if (!variant) {
            // Combinazione inesistente: impedisci l'aggiunta della variante sbagliata
            if (hiddenInput) hiddenInput.value = '';
            updateButton(false);
            return;
          }

          if (hiddenInput) hiddenInput.value = variant.id;
          updatePrice(variant);
          updateStock(variant);
          updateButton(variant.available);
          if (mainImage && variant.featured_image) mainImage.src = variant.featured_image;
        });
      });

      // Stato iniziale: corregge la disponibilità server-rendered per la combinazione preselezionata.
      updateOptionAvailability();
    });
  }

  // ---------- Header menu (mobile drawer + submenu accordion) ----------
  function initHeaderMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    if (!menu || !toggle) return;

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Chiudi menu');
      document.body.classList.add('is-mobile-menu-open');
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Apri menu');
      document.body.classList.remove('is-mobile-menu-open');
    }

    toggle.addEventListener('click', function() {
      if (menu.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    document.querySelectorAll('[data-mobile-menu-close]').forEach(function(el) {
      el.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });

    // Submenu accordion inside drawer
    menu.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          if (expanded) panel.setAttribute('hidden', '');
          else panel.removeAttribute('hidden');
        }
      });
    });

    // If viewport grows past mobile breakpoint, ensure drawer is closed
    var mq = window.matchMedia('(min-width: 1024px)');
    var onChange = function(ev) { if (ev.matches) closeMenu(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  // ---------- Cart drawer ----------
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-cart-drawer-open');
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-cart-drawer-open');
    }
    function setLoading(state) {
      drawer.classList.toggle('is-loading', !!state);
    }

    function refresh(sectionHTML) {
      if (!sectionHTML) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = sectionHTML.trim();
      var newDrawer = tmp.querySelector('[data-cart-drawer]');
      if (!newDrawer) return;

      // Replace body
      var oldBody = drawer.querySelector('[data-cart-drawer-body]');
      var newBody = newDrawer.querySelector('[data-cart-drawer-body]');
      if (oldBody && newBody) oldBody.replaceWith(newBody);

      // Replace footer (may be absent if cart is empty)
      var panel = drawer.querySelector('.cart-drawer__panel');
      var oldFooter = drawer.querySelector('[data-cart-drawer-footer]');
      var newFooter = newDrawer.querySelector('[data-cart-drawer-footer]');
      if (oldFooter && newFooter) {
        oldFooter.replaceWith(newFooter);
      } else if (oldFooter && !newFooter) {
        oldFooter.remove();
      } else if (!oldFooter && newFooter && panel) {
        panel.appendChild(newFooter);
      }

      // Update count badges everywhere on the page
      var countNode = newDrawer.querySelector('[data-cart-count]');
      var newCount = countNode ? countNode.textContent.trim() : '0';
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = newCount;
      });
    }

    // Toggle from header (and any other place)
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-cart-drawer-toggle]');
      if (toggle) {
        e.preventDefault();
        if (drawer.classList.contains('is-open')) close();
        else open();
        return;
      }
      var closer = e.target.closest('[data-cart-drawer-close]');
      if (closer && drawer.contains(closer)) {
        e.preventDefault();
        close();
      }
    });

    // ESC closes
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Quantity / remove (event delegation, drawer body is replaced on each refresh)
    drawer.addEventListener('click', function(e) {
      var qtyBtn = e.target.closest('[data-cart-qty-change]');
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (!qtyBtn && !removeBtn) return;

      var lineEl = e.target.closest('[data-cart-item]');
      if (!lineEl) return;
      var key = lineEl.getAttribute('data-line-key');
      if (!key) return;

      var newQty;
      if (removeBtn) {
        newQty = 0;
      } else {
        var delta = parseInt(qtyBtn.getAttribute('data-cart-qty-change'), 10) || 0;
        var current = parseInt(lineEl.querySelector('[data-cart-qty]').textContent, 10) || 0;
        newQty = Math.max(0, current + delta);
      }

      changeLine(key, newQty);
    });

    function changeLine(key, qty) {
      setLoading(true);
      var body = new URLSearchParams();
      body.set('id', key);
      body.set('quantity', String(qty));
      body.set('sections', 'cart-drawer');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: body.toString()
      })
        .then(function(r) { return r.json(); })
        .then(function(json) {
          if (json && json.sections && json.sections['cart-drawer']) {
            refresh(json.sections['cart-drawer']);
          }
        })
        .finally(function() { setLoading(false); });
    }

    // Intercept product form submit -> AJAX add to cart
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      // Match Shopify add-to-cart forms (action ends with /cart/add)
      if (!/\/cart\/add(\?.*)?$/.test(action)) return;

      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var originalLabel = submitBtn ? submitBtn.textContent : null;
      if (submitBtn) submitBtn.disabled = true;

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function(r) {
          return r.json().then(function(json) {
            if (!r.ok) return Promise.reject(json);
            return json;
          });
        })
        .then(function(json) {
          if (json && json.sections && json.sections['cart-drawer']) {
            refresh(json.sections['cart-drawer']);
          }
          open();
        })
        .catch(function(err) {
          var msg = (err && (err.description || err.message)) || 'Si è verificato un errore. Riprova.';
          showFormError(form, msg);
        })
        .finally(function() {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (originalLabel != null) submitBtn.textContent = originalLabel;
          }
        });
    });

    function showFormError(form, message) {
      var existing = form.querySelector('[data-cart-form-error]');
      if (!existing) {
        existing = document.createElement('p');
        existing.setAttribute('data-cart-form-error', '');
        existing.style.cssText = 'color:#B54A36;font-size:12px;margin-top:10px;';
        var row = form.querySelector('.product-main__buy-row') || form;
        row.parentNode.insertBefore(existing, row.nextSibling);
      }
      existing.textContent = message;
    }

    // Public API for other modules (outfit add, addToCart helper)
    window.CartDrawer = { open: open, close: close, refresh: refresh };
  }

  // ---------- Related products (async Shopify recommendations) ----------
  function initRelatedProducts() {
    document.querySelectorAll('[data-product-recommendations][data-url]').forEach(function(el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function(html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var fresh = tmp.querySelector('[data-product-recommendations]');
          if (fresh && fresh.querySelector('.product-grid')) {
            el.replaceWith(fresh);
          } else {
            el.remove();
          }
        })
        .catch(function() { el.remove(); });
    });
  }

  // ---------- Popup promozionale ----------
  function initPopup() {
    var popup = document.querySelector('[data-popup]');
    if (!popup) return;

    var designMode = popup.getAttribute('data-design-mode') === 'true';
    var trigger = popup.getAttribute('data-trigger') || 'delay';
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    var scrollPct = parseInt(popup.getAttribute('data-scroll'), 10) || 40;
    var frequency = popup.getAttribute('data-frequency') || 'session';
    var freqDays = parseInt(popup.getAttribute('data-frequency-days'), 10) || 7;
    var storageKey = popup.getAttribute('data-storage-key') || 'mashupstyle_popup';

    var opened = false;

    function hasBeenSeen() {
      if (frequency === 'always') return false;
      try {
        if (frequency === 'session') {
          return sessionStorage.getItem(storageKey) === '1';
        }
        var raw = localStorage.getItem(storageKey);
        if (!raw) return false;
        if (frequency === 'once') return true;
        if (frequency === 'days') {
          var ts = parseInt(raw, 10);
          if (!ts) return false;
          return (Date.now() - ts) < freqDays * 86400000;
        }
      } catch (e) {}
      return false;
    }

    function markSeen() {
      if (designMode) return;
      try {
        if (frequency === 'session') {
          sessionStorage.setItem(storageKey, '1');
        } else if (frequency === 'once') {
          localStorage.setItem(storageKey, '1');
        } else if (frequency === 'days') {
          localStorage.setItem(storageKey, String(Date.now()));
        }
        // 'always' => non salva nulla
      } catch (e) {}
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    function open() {
      if (opened) return;
      opened = true;
      popup.hidden = false;
      void popup.offsetWidth; // forza reflow per la transizione
      popup.classList.add('is-open');
      document.body.classList.add('is-popup-open');
      document.addEventListener('keydown', onKey);
    }

    function close() {
      popup.classList.remove('is-open');
      document.body.classList.remove('is-popup-open');
      document.removeEventListener('keydown', onKey);
      markSeen();
      setTimeout(function() { popup.hidden = true; }, 300);
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function(el) {
      el.addEventListener('click', close);
    });

    // Il click sull'immagine (link) conta come "visto"
    var link = popup.querySelector('[data-popup-link]');
    if (link) link.addEventListener('click', markSeen);

    // Nell'editor mostra sempre il popup, senza consumare la frequenza
    if (designMode) { open(); return; }

    if (hasBeenSeen()) return;

    if (trigger === 'immediate') {
      open();
    } else if (trigger === 'delay') {
      setTimeout(open, delay * 1000);
    } else if (trigger === 'scroll') {
      var onScroll = function() {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        var pct = max <= 0 ? 100 : (window.scrollY / max) * 100;
        if (pct >= scrollPct) {
          open();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else if (trigger === 'exit') {
      var onLeave = function(e) {
        if (e.clientY <= 0) {
          open();
          document.removeEventListener('mouseout', onLeave);
        }
      };
      document.addEventListener('mouseout', onLeave);
    }
  }

  // ---------- Init ----------
  document.addEventListener('DOMContentLoaded', function() {
    initBrandTabs();
    initCarousels();
    initProductGallery();
    initWishlist();
    initOutfit();
    initQuantity();
    initVariantSelection();
    initHeaderMenu();
    initCartDrawer();
    initRelatedProducts();
    initPopup();
  });

  // ---------- Supporto editor di tema Shopify ----------
  // Le sezioni vengono ri-renderizzate via AJAX (niente DOMContentLoaded):
  // ri-inizializziamo il popup quando la sua sezione viene caricata o selezionata.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      if (e.target && e.target.querySelector('[data-popup]')) initPopup();
    });
    document.addEventListener('shopify:section:select', function(e) {
      if (e.target && e.target.querySelector('[data-popup]')) initPopup();
    });
  }
})();
